import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Button,
  Row,
} from "reactstrap";
import * as Yup from "yup";
import Select from "react-select";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import { get, post, put, uri } from "helpers/api_helper";
import * as api from "../../constants/api_constants";
import { charactersWithSpaces, zipcode } from "helpers/validations/regex";
import { showErrorToast, showSuccessToast } from "helpers/toastMessages";
import {
  getAllCountries,
  getCitiesForState,
  getStatesForCountry,
} from "helpers/utils/locationUtil";
import DragAndDropComponent from "components/FileUploadDrag/DragAndDrop";

export default function AddAssignment() {
  const navigate = useNavigate();
  const { AssignId } = useParams();
  const [projects, setProjects] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [assignmentData,    setAssignmentData] = useState({
    assignmentTitle: "",
    startDate: "",
    endDate: "",
    placementType: "",
    status: "",
    project: "",
    hiringType: "",
    workType: "",
    workLocationCountry: "",
    workLocationZipCode: "",
    workLocationProvince: "",
    workLocationCity: "",
    workLocationAddress: "",
    reportingManagerId: "",
    reportingManagerName: "",
    reportingManagerNumber: "",
    reportingManagerEmail: "",
    projectManager: "",
    recruitmentDetailsId: "",
    jobId: "",
    recruitmentManager: "",
    recruiter: "",
    externalRecruiters: [],
    billDetailsId: "",
    payType: "",
    billType: "",
    payRate: "",
    effectiveFrom: "",
    currency: "",
    comments: "",
    teamMembers: [],
    jiraURL: "",
    gitURL: "",
    assignmentDocuments: [], // Add assignmentDocuments to store fetched documents
  });
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [countriesWithLabelAndCurrency, setCountriesWithLabelAndCurrency] =
    useState([]);
  const [fileUploaders, setFileUploaders] = useState([0]);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function doFetchCalls() {
      await fetchProjects();
      await employeeData();
      await fetchCountries();
      if (AssignId) {
        await fetchAssignment(AssignId);
      } else {
        setIsLoading(false);
      }
    }

    doFetchCalls();

    return () => {};
  }, [AssignId]);

  // const fetchCountries = async () => {
  //   const fetchedCountries = getAllCountries();
  //   setCountries(fetchedCountries);
  //   const countriesWithCurrencies = fetchedCountries.map((country) => ({
  //     label: country.name,
  //     currency: country.currency,
  //   }));
  //   setCountriesWithLabelAndCurrency(countriesWithCurrencies);
  // };

  const fetchCountries = async () => {
    try {
      const fetchedCountries = await getAllCountries();
      setCountries(fetchedCountries);

      // ✅ Extract unique currencies with their labels
      const currencyMap = new Map();

      fetchedCountries.forEach((country) => {
        if (country.currency && !currencyMap.has(country.currency)) {
          currencyMap.set(country.currency, {
            label: country.name,
            currency: country.currency,
          });
        }
      });

      const uniqueCurrencies = Array.from(currencyMap.values());
      setCountriesWithLabelAndCurrency(uniqueCurrencies);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []); // ✅ Run only once when component mounts

  const employeeData = async () => {
    try {
      const response = await get(api.GET_ALL_EMPLOYEES_NAME_ID_MAIL);
      const employeeResponse = response.map((item) => ({
        id: item.employeeId,
        value: item.employeeId,
        label: `${item.firstName} ${item.lastName}`,
        number: item.mobile,
        email: item.email,
      }));
      setEmployees(employeeResponse);
    } catch (error) {
      console.log("Error fetching employees data");
    }
  };

  const fetchProjects = async () => {
    try {
      const projectsData = await get(api.GET_ALL_PROJECTS_ID_NAMES);
      console.log("projectsData",projectsData);
      
      const updatedProjectData = projectsData?.paginationResponse?.data.map(
        (item) => ({
          value: item.projectId,
          label: `${item.projectName} - (${item.projectCode})`,
        })
      );
      setProjects(updatedProjectData);
    } catch (error) {
      console.log("Error fetching projects data");
    }
  };

  const fetchAssignment = async (assignId) => {
    try {
      const response = await get(api.GET_ASSIGNMENT_BY_ID(assignId));
      const assignData = response.data;
     

      // Assuming assignData.assignmentDocuments contains an array of document IDs
      const assignmentDocuments = assignData?.assignmentDocuments || [];

      if (parseInt(assignmentDocuments[0])) {
        const fileResponse = await get(
          `${uri}/fileservice/api/files/view/${assignmentDocuments[0]}`
        );

        const initialUploadedFiles = {
          id: fileResponse.id,
          fileName: fileResponse.fileName,
          name: fileResponse.fileName,
        };
        setUploadedFiles(initialUploadedFiles);
      }

      setAssignmentData({
        assignmentTitle: assignData?.assignmentTitle || "",
        startDate: assignData?.startDate?.slice(0, 10) || "",
        endDate: assignData?.endDate?.slice(0, 10) || "",
        placementType: assignData?.placementType || "",
        status: assignData?.status || "",
        project: assignData?.projectId || "",
        hiringType: assignData?.hiringType || "",
        workType: assignData?.workLocationDTO?.workType || "",
        workLocationCountry: assignData?.workLocationDTO?.country || "",
        workLocationZipCode: assignData?.workLocationDTO?.zipCode || "",
        workLocationProvince: assignData?.workLocationDTO?.province || "",
        workLocationCity: assignData?.workLocationDTO?.city || "",
        workLocationAddress: assignData?.workLocationDTO?.address || "",
        workDetailsId: assignData?.workLocationDTO?.id || "",
        reportingManagerId:
          assignData?.workLocationDTO?.reportingManagerId || "",
        reportingManagerName:
          assignData?.workLocationDTO?.reportingManagerId || "",
        reportingManagerNumber:
          assignData?.workLocationDTO?.reportingManagerNumber || "",
        reportingManagerEmail:
          assignData?.workLocationDTO?.reportingManagerEmail || "",
        projectManager: assignData?.recruitmentDTO?.projectManagerId || "",
        recruitmentDetailsId: assignData?.recruitmentDTO?.id || "",
        jobId: assignData?.recruitmentDTO?.jobId || "",
        recruitmentManager:
          assignData?.recruitmentDTO?.recruitmentManagerId || "",
        recruiter: assignData?.recruitmentDTO?.recruiterId || "",
        externalRecruiters:
          assignData?.recruitmentDTO?.externalRecruitersId || [],
        billDetailsId: assignData?.billingDTO?.id || "",
        payType: assignData?.billingDTO?.payType || "",
        billType: assignData?.billingDTO?.billType || "",
        payRate: assignData?.billingDTO?.payRate || "",
        effectiveFrom:
          assignData?.billingDTO?.effectiveForm?.slice(0, 10) || "",
        currency: assignData?.billingDTO?.currencyType || "",
        comments: assignData?.billingDTO?.comments || "",
        teamMembers: assignData?.employeeIds || [],
        jiraURL: assignData?.jiraUrl || "",
        gitURL: assignData?.gitHubUrl || "",
        assignmentDocuments,
      });
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching assignment data:", error);
      setIsLoading(false);
    }
  };

  // console.log(assignmentData);

  const handleManagerChange = (e) => {
    const selectedId = parseInt(e.target.value);
    const selectedManager = employees.find(
      (employee) => employee.value === selectedId
    );
    validation.setFieldValue(
      "reportingManagerName",
      selectedManager ? selectedManager.value : ""
    );
    validation.setFieldValue(
      "reportingManagerNumber",
      selectedManager ? selectedManager.number : ""
    );
    validation.setFieldValue(
      "reportingManagerEmail",
      selectedManager ? selectedManager.email : ""
    );
  };

  const handleFileUpload = (response) => {
    setUploadedFiles({ ...response, name: response.fileName });
  };

  const addUploader = () => {
    setFileUploaders((prev) => [...prev, prev.length]);
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: assignmentData,
    validationSchema: Yup.object({
      assignmentTitle: Yup.string()
        .required("Please enter assignment title")
        .matches(charactersWithSpaces, "Title should contain only characters"),
      startDate: Yup.date().required("Please enter start date"),
      endDate: Yup.date()
        .required("Please enter end date")
        .min(Yup.ref("startDate"), "End date must be after start date"),
      status: Yup.string().required("Please select status"),
      project: Yup.string().required("Please select project"),
      payType: Yup.string().required("Please select pay type"),
      billType: Yup.string().required("Please select bill type"),
      payRate: Yup.number()
        .required("Please enter pay rate")
        .positive("Pay rate must be positive"),
      effectiveFrom: Yup.date(),
      jiraURL: Yup.string().url("Please enter a valid URL"),
      gitURL: Yup.string().url("Please enter a valid URL"),
    }),
    onSubmit: async (values) => {
      try {
        // Prepare document IDs for submission
        // const documentIds = Object.values(uploadedFiles)
        //   .filter((file) => file.id)
        //   .map((file) => file.id);

        const payload = {
          assignmentDTO: {
            assignmentId: parseInt(AssignId) || undefined,
            assignmentTitle: values.assignmentTitle,
            startDate: values.startDate,
            subscriptionId: 100,
            projectId: values.project,
            endDate: values.endDate,
            status: values.status,
            placementType: values.placementType,
            hiringType: values.hiringType,
            assignmentDocuments: [uploadedFiles?.id], // Include document IDs
            jiraUrl: values.jiraURL,
            gitHubUrl: values.gitURL,
            workLocationDTO: {
              id: values.workDetailsId || "",
              workType: values.workType,
              country: values.workLocationCountry,
              city: values.workLocationCity,
              address: values.workLocationAddress,
              province: values.workLocationProvince,
              reportingManagerId: parseInt(values.reportingManagerName),
              reportingManagerName: parseInt(values.reportingManagerName),
              reportingManagerNumber: values.reportingManagerNumber,
              reportingManagerEmail: values.reportingManagerEmail,
              zipCode: values.workLocationZipCode,
            },
            recruitmentDTO: {
              id: values.recruitmentDetailsId || "",
              projectManagerId: parseInt(values.projectManager),
              jobId: values.jobId,
              recruiterId: values.recruiter,
              recruitmentManagerId: parseInt(values.recruitmentManager),
              externalRecruiter: values.externalRecruiters,
            },
            billingDTO: {
              id: values.billDetailsId || "",
              payType: values.payType,
              billType: values.billType,
              payRate: values.payRate,
              currencyType: values.currency,
              comments: values.comments,
              effectiveForm: values.effectiveFrom,
            },
            employeeIds: values.teamMembers,
          },
        };

        if (AssignId) {
          const response = await put(
            api.UPDATE_ASSIGNMENT_BY_ID(AssignId),
            payload
          );
          showSuccessToast("Assignment updated successfully");
          navigate("/assignments");
        } else {
          const response = await post(api.CREATE_ASSIGNMENT, payload);
          showSuccessToast("Assignment created successfully");
          navigate("/assignments");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        showErrorToast("Something went wrong");
      }
    },
  });

  useEffect(() => {
    if (validation.values.workLocationCountry) {
      const fetchedStates = getStatesForCountry(
        validation.values.workLocationCountry
      );
      setStates(fetchedStates);
    }
  }, [validation.values.workLocationCountry]);

  useEffect(() => {
    if (
      validation.values.workLocationProvince &&
      validation.values.workLocationCountry
    ) {
      const fetchedCities = getCitiesForState(
        validation.values.workLocationCountry,
        validation.values.workLocationProvince
      );
      setCities(fetchedCities);
    }
  }, [
    validation.values.workLocationProvince,
    validation.values.workLocationCountry,
  ]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="page-content">
      <Container fluid={true} style={{ padding: "0px", gap: "10px" }}>
        <PageSubHeader
          heading={AssignId ? "Edit Assignment" : "Add Assignment"}
          routePath={"Home"}
          pageName={AssignId ? "Edit Assignment" : "Add Assignment"}
        />
        <Row className="p-4">
          <Col>
            <Card>
              <CardBody>
                <Form
                  className="row g-3 needs-validation py-4"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <Row className="card-group">
                    <Col xs={12} className="card-header">
                      <p className="form-header">Assignment Details</p>
                    </Col>
                    <Col md="6">
                      <FormGroup className="my-3">
                        <Label htmlFor="assignmentTitle">
                          Assignment Title{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="assignmentTitle"
                          type="text"
                          className="form-control"
                          id="assignmentTitle"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.assignmentTitle || ""}
                          invalid={
                            validation.touched.assignmentTitle &&
                            validation.errors.assignmentTitle
                          }
                        />
                        {validation.touched.assignmentTitle &&
                          validation.errors.assignmentTitle && (
                            <FormFeedback type="invalid">
                              {validation.errors.assignmentTitle}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="my-3">
                        <Label htmlFor="teamMembers">
                          Team <span className="text-danger">*</span>
                        </Label>
                        <Select
                          isMulti
                          name="teamMembers"
                          options={employees}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          value={employees.filter((emp) =>
                            validation.values.teamMembers.includes(emp.value)
                          )}
                          onChange={(selectedOptions) => {
                            const selectedTeam = selectedOptions
                              ? selectedOptions.map((item) => item.value)
                              : [];
                            validation.setFieldValue(
                              "teamMembers",
                              selectedTeam
                            );
                          }}
                          onBlur={() =>
                            validation.setFieldTouched("teamMembers", true)
                          }
                        />
                        {validation.touched.teamMembers &&
                          validation.errors.teamMembers && (
                            <div className="text-danger">
                              {validation.errors.teamMembers}
                            </div>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="reportingManagerName">
                          Reporting Manager Name{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="reportingManagerName"
                          type="select"
                          className="form-select"
                          id="reportingManagerName"
                          value={validation.values.reportingManagerName || ""}
                          onChange={handleManagerChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.reportingManagerName &&
                            validation.errors.reportingManagerName
                          }
                        >
                          <option value="">Select Manager Name</option>
                          {employees.map((data) => (
                            <option key={data.value} value={data.value}>
                              {data.label}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.reportingManagerName &&
                          validation.errors.reportingManagerName && (
                            <FormFeedback type="invalid">
                              {validation.errors.reportingManagerName}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="project">
                          Project <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="project"
                          type="select"
                          className="form-select"
                          id="project"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.project || ""}
                          invalid={
                            validation.touched.project &&
                            validation.errors.project
                          }
                        >
                          <option value="">Select Project</option>
                          {projects.map((data) => (
                            <option key={data.value} value={data.value}>
                              {data.label}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.project &&
                          validation.errors.project && (
                            <FormFeedback type="invalid">
                              {validation.errors.project}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="startDate">
                          Start Date <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="startDate"
                          type="date"
                          className="form-control"
                          id="startDate"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.startDate || ""}
                          invalid={
                            validation.touched.startDate &&
                            validation.errors.startDate
                          }
                        />
                        {validation.touched.startDate &&
                          validation.errors.startDate && (
                            <FormFeedback type="invalid">
                              {validation.errors.startDate}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="endDate">
                          End Date <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="endDate"
                          type="date"
                          className="form-control"
                          id="endDate"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.endDate || ""}
                          invalid={
                            validation.touched.endDate &&
                            validation.errors.endDate
                          }
                        />
                        {validation.touched.endDate &&
                          validation.errors.endDate && (
                            <FormFeedback type="invalid">
                              {validation.errors.endDate}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="status">
                          Status <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="status"
                          type="select"
                          className="form-select"
                          id="status"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.status || ""}
                          invalid={
                            validation.touched.status &&
                            validation.errors.status
                          }
                        >
                          <option value="">Select Status</option>
                          <option value="YET_TO_START">Yet to Start</option>
                          <option value="ONGOING">On Going</option>
                          <option value="COMPLETED">Completed</option>
                        </Input>
                        {validation.touched.status &&
                          validation.errors.status && (
                            <FormFeedback type="invalid">
                              {validation.errors.status}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="jiraURL">Jira URL</Label>
                        <Input
                          name="jiraURL"
                          type="text"
                          className="form-control"
                          id="jiraURL"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.jiraURL}
                          invalid={
                            validation.touched.jiraURL &&
                            !!validation.errors.jiraURL
                          }
                        />
                        {validation.touched.jiraURL &&
                          validation.errors.jiraURL && (
                            <FormFeedback type="invalid">
                              {validation.errors.jiraURL}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="gitURL">GitHub URL</Label>
                        <Input
                          name="gitURL"
                          type="text"
                          className="form-control"
                          id="gitURL"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.gitURL}
                          invalid={
                            validation.touched.gitURL &&
                            !!validation.errors.gitURL
                          }
                        />
                        {validation.touched.gitURL &&
                          validation.errors.gitURL && (
                            <FormFeedback type="invalid">
                              {validation.errors.gitURL}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="card-group p-2 my-2">
                    <Col xs={12} className="card-header">
                      <p className="form-header">Billing Information</p>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="payType">
                          Pay Type <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="select"
                          name="payType"
                          className="form-select"
                          id="payType"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.payType || ""}
                          invalid={
                            validation.touched.payType &&
                            validation.errors.payType
                          }
                        >
                          <option value="">Select Pay Type</option>
                          <option value="W2">W2</option>
                          <option value="FULL_TIME">Full Time</option>
                          <option value="C2C">C2C</option>
                          <option value="C2H">C2H</option>
                        </Input>
                        {validation.touched.payType &&
                          validation.errors.payType && (
                            <FormFeedback type="invalid">
                              {validation.errors.payType}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="billType">
                          Bill Type <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="select"
                          name="billType"
                          className="form-select"
                          id="billType"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.billType || ""}
                          invalid={
                            validation.touched.billType &&
                            validation.errors.billType
                          }
                        >
                          <option value="">Select Bill Type</option>
                          <option value="HOURLY">Hourly</option>
                          <option value="DAY">Day</option>
                          <option value="MONTHLY">Monthly</option>
                          <option value="YEARLY">Yearly</option>
                          <option value="FIXED">Fixed</option>
                        </Input>
                        {validation.touched.billType &&
                          validation.errors.billType && (
                            <FormFeedback type="invalid">
                              {validation.errors.billType}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="currency">Currency</Label>
                        <Input
                          name="currency"
                          type="select"
                          className="form-control"
                          id="currency"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.currency || ""}
                          invalid={
                            validation.touched.currency &&
                            validation.errors.currency
                          }
                        >
                          <option value="">Select</option>
                          {countriesWithLabelAndCurrency.map((country) => (
                            <option
                              key={country.currency}
                              value={country.currency}
                            >
                              {country.currency}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.currency &&
                          validation.errors.currency && (
                            <FormFeedback type="invalid">
                              {validation.errors.currency}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="payRate">
                          Pay Rate <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="payRate"
                          type="text"
                          className="form-control"
                          id="payRate"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.payRate || ""}
                          invalid={
                            validation.touched.payRate &&
                            validation.errors.payRate
                          }
                        />
                        {validation.touched.payRate &&
                          validation.errors.payRate && (
                            <FormFeedback type="invalid">
                              {validation.errors.payRate}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="effectiveFrom">Effective From</Label>
                        <Input
                          name="effectiveFrom"
                          type="date"
                          className="form-control"
                          id="effectiveFrom"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.effectiveFrom || ""}
                          invalid={
                            validation.touched.effectiveFrom &&
                            validation.errors.effectiveFrom
                          }
                        />
                        {validation.touched.effectiveFrom &&
                          validation.errors.effectiveFrom && (
                            <FormFeedback type="invalid">
                              {validation.errors.effectiveFrom}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="comments">Notes</Label>
                        <Input
                          name="comments"
                          type="textarea"
                          rows={3}
                          className="form-control"
                          id="comments"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.comments || ""}
                          invalid={
                            validation.touched.comments &&
                            validation.errors.comments
                          }
                        />
                        {validation.touched.comments &&
                          validation.errors.comments && (
                            <FormFeedback type="invalid">
                              {validation.errors.comments}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* <Row className="card-group p-2 my-2">
                    <Col xs={12} className="card-header">
                      <p className="form-header">Assignment Documents</p>
                    </Col>
                    {fileUploaders.map((uploaderId) => (
                      <Col key={uploaderId} md="3" className="position-relative mt-3">
                        <div className="rounded py-2 pe-4">
                          <DragAndDropComponent
                            uploaderId={uploaderId}
                            initialFile={uploadedFiles[uploaderId]}
                            handleFileUpload={(response) => handleFileUpload(uploaderId, response)}
                          />
                          {uploadedFiles[uploaderId]?.id && (
                            <Button
                              color="danger"
                              outline
                              size="sm"
                              onClick={() => removeUploader(uploaderId)}
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                fontSize: "1rem",
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                              }}
                            >
                              ×
                            </Button>
                          )}
                        </div>
                      </Col>
                    ))}
                    <Col xs={12} className="d-flex justify-content-end my-3">
                      <Button color="primary" onClick={addUploader}>
                        + Add Files
                      </Button>
                    </Col>
                  </Row> */}

                  <Row className="card-group mt-3 flex">
                    <Col xs={12} className="card-header">
                      <p className="form-header">Assignment Documents</p>
                    </Col>
                    <Col md={3}>
                      <div className="position-relative rounded py-2 pe-4">
                        <DragAndDropComponent
                          initialFile={uploadedFiles}
                          handleFileUpload={handleFileUpload}
                        />
                        {/* {uploadedFiles?.id && (
                          <button
                            type="button"
                            onClick={() => removeUploader(0)} // Assuming a single uploader with ID 0
                            className="btn btn-outline-danger btn-sm"
                            style={{
                              fontSize: "1rem",
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                            }}
                          >
                            ×
                          </button>
                        )} */}
                      </div>
                    </Col>
                    {/* <Col xs={12} className="d-flex justify-content-end my-3">
                      <Button color="primary" onClick={addUploader}>
                        + Add Files
                      </Button>
                    </Col> */}
                  </Row>

                  <Footer save={validation.handleSubmit} />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
